import React from "react";

import { Typography, Grid, Skeleton } from "@mui/material";

import { BlockStandard } from "components/admin/BlockStandard";
import { useYearlyBillsContext } from "contexts/BillingContext";
import { ChartEconomy } from "components/charts/ChartEconomy";
import { ChartConsumption } from "components/charts/ChartConsumption";
import { ptBR } from "date-fns/locale";
import { formatMoneyLabel, formatKwhLabel } from "logic/Charts";

export const YearlyBilling = () => {
  const {
    isLoading,
    economy,
    credits,
    consumption,
    generationKwh,
    supplierKwh,
  } = useYearlyBillsContext();

  const accEconomy = economy?.length
    ? economy
        .reduce((acc, { value }) => acc + value, 0)
        .toLocaleString(ptBR.code, {
          style: "currency",
          currency: "BRL",
        })
    : "R$ 0,00";

  const hasGeneration =
    Array.isArray(generationKwh) && generationKwh.length > 0;

  return (
    <>
      <BlockStandard title="Economia">
        <Grid container direction="row" justifyContent="space-between">
          <Typography>Acumulada no ano</Typography>
          <Typography variant="h2" component="span">
            {isLoading ? <Skeleton width={150} /> : accEconomy}
          </Typography>
        </Grid>
        <ChartEconomy
          data={economy || []}
          isLoading={isLoading}
          formatLabel={formatMoneyLabel}
        />
      </BlockStandard>
      <BlockStandard title="Consumo">
        <Typography>Soma de energia verde com a da distribuidora</Typography>
        <ChartConsumption
          isLoading={isLoading}
          mainData={hasGeneration ? generationKwh : consumption ?? []}
          secondaryData={hasGeneration ? supplierKwh ?? [] : []}
          mainLabel={hasGeneration ? "Energia verde" : "Consumo"}
          secondaryLabel={hasGeneration ? "Distribuidora" : ""}
        />
      </BlockStandard>
      <BlockStandard title="Saldo de Créditos" hideDivider>
        <Typography>
          Acompanhe a variação mensal do seu saldo de créditos
        </Typography>
        <ChartEconomy
          data={credits || []}
          isLoading={isLoading}
          formatLabel={formatKwhLabel}
        />
      </BlockStandard>
    </>
  );
};
